/**
 * BucketHeader — bildirim grubu başlığı (Bugün / Bu Hafta / Daha Önce).
 *
 * CSS `uppercase` KULLANILMAZ — Türkçe İ/I bug'ı (bkz. src/lib/textCase.js).
 * Büyütme render anında localeUpperCase() ile yapılır.
 *
 * Gerçek <h3 id> döner — üst bileşen bunu <section aria-labelledby> ile sarar.
 */
import { localeUpperCase } from '../../lib/textCase';

export default function BucketHeader({ label, lang, headerId }) {
  return (
    <h3
      id={headerId}
      className="px-3 pt-3 pb-1 text-[10px] font-black tracking-widest text-[var(--text-secondary)]"
    >
      {localeUpperCase(label, lang)}
    </h3>
  );
}
